export default __webpack_public_path__ + "static/geothermie-a803c5f100c81fe8526947b13f0936c5.jpg";